// extracted by mini-css-extract-plugin
export var content = "content-module--content--3tWs5";
export var lighter = "content-module--lighter--3sE_t";